import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" {...props}><path fill="#19336A" fillRule="evenodd" stroke="#19336A" strokeLinecap="round" d="M6.055 6.903l-4.88-4.879a.6.6 0 01.85-.848l4.878 4.879 4.88-4.88a.6.6 0 01.848.85L7.75 6.902l4.88 4.88a.6.6 0 11-.849.848L6.903 7.75l-4.879 4.88a.6.6 0 11-.848-.849l4.879-4.879z" /></svg>);